export default "__VITE_ASSET__xvAfvB_O__"